/**
 * Returns a copy of the `obj` with the updated `key`.
 * @private
 * @param  {Object} obj
 * @param  {string} key
 * @param  {*} value
 * @returns {Object}
 */
function updateKeyReduxUtil (obj, key, value) {
  if (Array.isArray(obj)) {
    return updateArrayKeyReduxUtil(obj, key, value)
  }
  obj = { ...obj }
  // Delete the key if the value is undefined
  if (value === undefined) {
    delete obj[key]
  } else {
    // Otherwise set the key
    obj[key] = value
  }
  return obj
}

/**
 * Returns a copy of the `arr` with the updated `key`.
 * @private
 * @param  {Array} arr
 * @param  {string} key
 * @param  {*} value
 * @returns {Array}
 */
function updateArrayKeyReduxUtil (arr, key, value) {
  arr = [...arr]
  if (value === undefined) {
    // Remove the index if the value is `undefined`
    arr.splice(key, 1)
  } else if (key === 'null') {
    // Append the value if the key is the string 'null'
    arr.push(value)
  } else {
    // Otherwise, update the index
    arr[key] = value
  }
  return arr
}

/**
 * Sets a instance's attribute at the given path with the given value.
 * @param {Object} obj
 * @param {string} path
 * @param {*} value
 * @returns {Object}
 */
function setReduxUtil (obj, path, value) {
  const stepEnd = path.indexOf('.')
  if (stepEnd === -1) {
    return updateKeyReduxUtil(obj, path, value)
  }
  const curPath = path.substring(0, stepEnd)
  const nextPath = path.substring(stepEnd + 1)
  return updateKeyReduxUtil(obj, curPath, setReduxUtil(obj[curPath] || {}, nextPath, value))
}

export {
  setReduxUtil
}
